export const ParseStringyObjectBooleans = (shallowObj: Record<any, any>) => {
	const newResponse: any = {};
	Object.entries(shallowObj).forEach(([key, val]) => {
		newResponse[key] = val !== 'true' && val !== 'false' ? val : val === 'true';
	});

	return newResponse;
};
